import React from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { Modal } from "antd";
interface NoEmailProps extends BaseCompProps {
  attr?: any;
  open?: boolean;
  email?: string;
  changeOpen?(e: React.MouseEvent<HTMLElement, MouseEvent>): void;
}
const { useTranslation } = Hooks;
const NoEmail: React.FC<NoEmailProps> = ({ className, open = false, email = "", changeOpen }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  return (
    <Modal className={styles["no-email-modal"]} open={open} closable={false} title="" footer={null} width={400} onCancel={changeOpen}>
      <div className="no-email-modal-box">
        <p>{t("account.noEmailCodeTit")}</p>
        <p>{t("account.noEmailCodeTip")}:</p>
        <p>1. {t("account.noEmailCodeStepF")}</p>
        <p>2. {t("account.noEmailCodeStepS", { v1: email })}</p>
        <p>3. {t("account.noEmailCodeStepT")}</p>
        <div className="no-email-modal-box-btn" onClick={changeOpen}>{t("account.confirm")}</div>
      </div>
    </Modal>
  );
};
export default observer(NoEmail);
